function handleEnterDown(e: React.KeyboardEvent<HTMLElement>, func: () => void) {
  if (e.key === 'Enter') {
    func();
  }
}

export default handleEnterDown;
